<template>
  <div class="multi-search-search flexC mr-8">
    <div  v-if="config.title" class="option-title mr-6">
      {{ config.title }}
    </div>
    <component
    :is="componentName"
      ref="select"
      v-model="form.value"
      class="mr-8"
      v-bind="config"
      @change="change"
      @clear="clear"
    >
    </component>
    <cube-button
:disabled="!option"
type="defalut"
plain
@click="confirm"
      >确定</cube-button
    >
  </div>
</template>
<script>
export default {
  props: {
    parent: {
      type: Object,
      default: () => {
        return {}
      }
    },
    type: {
      type: String,
      default: ''
    },
    defaultSelect: {
      type: String,
      default: 'otter-select'
    }
  },
  data() {
    return {
      form: {
        value: ''
      },
      option: null
    }
  },
  computed: {
    config() {
      return this.parent.config ? this.parent.config : {}
    },
    componentName() {
      return this.config.conponent ? this.config.conponent : this.defaultSelect
    }
  },
  methods: {
    change(option) {
      console.log(option)
      this.option = option
    },
    clear() {
      this.$emit('clear', 'search')
    },
    reset() {
      this.form.value = ''
      this.option = null
    },
    confirm() {
      if (!this.option) return
      let option
      if (!this.config.option) {
        console.log(this.$refs.select)
        const { label, value } = this.$refs.select.defaultOption
        option = { label, value }
      } else {
        option = this.config.option
      }
      const { label, value } = option
      let tagLabel, tagValue
      if (this.config.multiple) {
        tagLabel = []
        tagValue = []
        this.option.forEach(item => {
          tagLabel.push(item[label])
          tagValue.push(item[value])
        })
        tagLabel = tagLabel.join(',')
      } else {
        tagLabel = this.option[label]
        tagValue = this.option[value]
      }
      // const tagLabel = this.option[label]
      // const tagValue = this.option[value]
      this.$emit('confirm', this.parent, { label: tagLabel, value: tagValue }, 'search')
      // this.form.value = ''
      // this.option = null
    }
  }
}
</script>
<style lang="scss" scoped>
.option-title {
  font-size: 14px;
  color: #686f80;
}
</style>
